import React, { Fragment, FunctionComponent } from "react";
import AnchorProps from "./AnchorProps.interface";

import { Link, useHistory, useLocation } from "react-router-dom";
import isBrowserContext from "helpers/isBrowserContext";
import getRelativeUrl from "helpers/getRelativeUrl";

const Anchor: FunctionComponent<AnchorProps> = (props) => {
    const link = typeof (props.to) === "string" ? getRelativeUrl(props.to) : "";

    const location = useLocation<any>();
    const history = useHistory();

    const saveScrollYState = () => {
        if (isBrowserContext()) {
            history.replace({
                pathname: location.pathname,
                search: location.search,
                hash: location.hash,
                state: {
                    ...location.state,
                    scrollY: window.scrollY
                }
            });
        }
    };

    return (
        <Fragment>
            {props.modal ? (
                <span style={props.style} aria-label={props.aria} className={props.className} onClick={props.onClick}>
                    {props.children}
                </span>
            ) : !props.to ? (
                <div className={props.className}>{props.children}</div>
            )
                : typeof (link) === "string" && (link.startsWith("http") || link.indexOf("#") > 0) ? (
                    <a aria-label={props.aria} style={props.style} className={props.className} href={link} target="_blank" rel="noreferrer">{props.children}</a>
                ) : (
                    <Link aria-label={props.aria} style={props.style} className={props.className} to={link} onClick={() => saveScrollYState()}>{props.children}</Link>
                )}
        </Fragment>
    );
};

export default Anchor;